import React from 'react';
import { Redirect, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import cookie from 'react-cookie';
import ReCAPTCHA from 'react-google-recaptcha';

import Button from '@material-ui/core/Button';

import { clearAllRetryTimers } from '../../utils/retrytimer';

import AppActions from '../../actions/app-actions';
import AppStore from '../../stores/app-store';

import Form from '../common/forms/form';
import TextInput from '../common/forms/textinput';
import PasswordInput from '../common/forms/passwordinput';
import FormCheckbox from '../common/forms/formcheckbox';

import { OAuth2Providers } from './oauth2providers';

import { preformatWithRequestID } from '../../helpers';
import { removeCookies } from '../../auth';

export default class Login extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
    location: PropTypes.object
  };

  constructor(props, context) {
    super(props, context);
    this.state = this._getState();
    this.state.failedStatus = 0;
    this.state.recaptcha = '';
    this.recaptchaSiteKey = AppStore.getRecaptchaSiteKey();
    this.recaptchaInstance;
  }

  UNSAFE_componentWillMount() {
    AppStore.changeListener(this._onChange.bind(this));
  }

  componentDidMount() {
    clearAllRetryTimers();
    AppActions.setCurrentUser(null);
    removeCookies();
  }

  componentWillUnmount() {
    AppStore.removeChangeListener(this._onChange.bind(this));
    AppActions.setSnackbar('');
  }

  _getState() {
    return {
      noExpiry: cookie.load('noExpiry'),
      redirectToReferrer: false
    };
  }

  _onChange() {
    this.setState(this._getState());
  }

  _handleLogin(formData) {
    var self = this;

    if (!formData.hasOwnProperty('email')) {
      return;
    }
    return AppActions.loginUser(formData, { captchacode: this.state.recaptcha })
      .then(token => {
        var options = {};
        if (!formData.noExpiry) {
          options = { maxAge: 900 };
        }

        // set no expiry as cookie to remember checkbox value
        cookie.save('noExpiry', formData.noExpiry.toString());

        // save token as cookie
        // set maxAge if noexpiry checkbox not checked
        cookie.save('JWT', token, options);

        //cookie.save('role', decodeUserRole(token));

        // logged in, so redirect
        self.setState({ redirectToReferrer: true });
        return AppActions.setSnackbar('');
      })
      .catch(err => {
        if (this.recaptchaSiteKey && this.recaptchaInstance) {
          this.recaptchaInstance.reset();
        }

        this.setState({ failedStatus: err.error.code });
        var errMsg = 'There was a problem signing in';
        if (err.res.body && Object.keys(err.res.body).includes('error')) {
          // if error message, check for "unauthorized"
          errMsg = err.res.body['error'] === 'unauthorized' ? 'The username or password is incorrect' : `${errMsg}: ${err.res.body['error']}`;
        }
        AppActions.setSnackbar(preformatWithRequestID(err.res, errMsg), null, 'Copy to clipboard');
      });
  }

  displayRecaptcha() {
    if (this.recaptchaSiteKey && this.state.failedStatus === 429) {
      return (
        < div style={{ margin: '8px 0px' }}>
          <ReCAPTCHA ref={e => this.recaptchaInstance = e} sitekey={this.recaptchaSiteKey} onChange={recaptcha => this.setState({ recaptcha })} />
        </div>
      );
    } else {
      return (<span></span>);
    }
  }

  render() {
    let { from } = { from: { pathname: '/' } };
    if (this.props.location.state && this.props.location.state.from.pathname !== '/ui/') {
      from = this.props.location.state.from;
    }
    let { noExpiry, redirectToReferrer } = this.state;
    if (redirectToReferrer) {
      return <Redirect to={from} />;
    }

    var title = 'Sign in';
    var buttonLabel = 'Sign in';
    return (
      <div className="full-screen">
        <div className="flexbox column" id="login-box" style={{ margin: '5% auto 0' }}>
          <h3>{title}</h3>
          <img src="assets/img/1-edgeway_logo_rgb.png" alt="loginlogo.png" className="margin-bottom-small" />

          <div className="flexbox centered margin-bottom">Sign in with:</div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {OAuth2Providers.map(provider => (
              <Button
                className="oauth-provider"
                variant="contained"
                key={provider.id}
                href={`/api/management/v1/useradm/oauth2/${provider.id}`}
                startIcon={provider.icon}
              >
                {provider.name}
              </Button>
            ))}
          </div>
          <h4 className="dashboard-header margin-top-large" style={{ display: 'flex', justifyContent: 'center' }}>
            <span style={{ padding: 15, top: -24 }}>or your email address</span>
          </h4>

          <Form
            showButtons={true}
            buttonColor="primary"
            onSubmit={formdata => {
              this._handleLogin(formdata);
            }}
            submitLabel={buttonLabel}
            submitButtonId="login_button"
          >
            <TextInput hint="Email *" label="Email *" id="email" required={true} validations="isLength:1,isEmail" />
            <PasswordInput className="margin-bottom-small" id="password" label="Password *" required={true} />
            <div className="flexbox">
              <Link style={{ marginLeft: '4px' }} to="/password">
                Forgot your password?
              </Link>
            </div>
            <FormCheckbox id="noExpiry" label="Stay signed in" checked={noExpiry === 'true'} />
          </Form>
          {this.displayRecaptcha()}
          <div className="margin-top text-muted">
            <div className="flexbox centered">
              Don&#39;t have an account?{' '}
              <Button color='primary' disableRipple={true} disableFocusRipple={true} disableElevation={true}
                style={{ marginLeft: '4px', textTransform: 'none', padding: 0 }} href='/api/management/v1/useradm/oauth2/auth0'>
                Sign up here
              </Button>
            </div>
          </div>

          <p style={{ paddingTop: '15px', textAlign: 'center', fontFamily: 'monospace', fontSize: '1em' }}> Contact EdgeWay support - support@edgeway.io </p>
        </div>
      </div >
    );
  }
}
